module.exports = __webpack_public_path__ + "img/faq.95fc524c.png";